<!-- <breadcrumbs>
    <breadcrumb route="/" [label]="'Components' | translate | async"></breadcrumb>
    <breadcrumb [currentRoute]="true" [label]="'component-types' | translate | async"></breadcrumb>
  </breadcrumbs> -->
<div class="panel">
  <div class="panel__header">
    <span class="panel__header__title" style="margin-top: 34px;">
      {{'Undercarriage Component Types' | translate | async}}
    </span>
  </div>
  <div class="panel__content no-padding">
    <div *ngIf="photoLoading"  style="margin-left: 39%; text-align: center;">
      <mat-spinner> </mat-spinner>
  </div>
    <table class="table table--full-width table--striped">
      <thead>
        <tr>
          <th class="text-center" style="text-align: center;">{{'Component Image' | translate | async}}</th>
          <th class="text-center">{{'Component Family' | translate | async}}</th>
          <th class="text-center">{{'Component Type Name' | translate | async}}</th>
          <th class="text-center" *ngFor="let component of imageList.ToolDeatails">{{ component.tool_name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let CompartType of imageList.Component">
          <td class="component-cell">
            <div class="component-photo-container">
              <img *ngIf="CompartType.CompartImagePath != null" class="observation-image__photo" [src]="sanitize(CompartType.CompartImagePath)"
                   (click)="viewCompartImage(CompartType.CompartImagePath, CompartType.ImageId, CompartType.comparttype_auto)" />
              <div *ngIf="CompartType.CompartImagePath == null"
                   class="upload-container" (click)="fileInputC.click()" title="{{ 'Add photo' | translate | async }}">
                <i class="material-icons upload-container__icon">add_a_photo</i>
                <input style="display: none;" type="file" #fileInputC (change)="onComponentImageChange($event,CompartType.comparttype_auto,CompartType.ImageId )">
              </div>
            </div>
          </td>
          <td class="text-center">{{ CompartType.ComponenetFamily }}</td>
          <td class="text-center">{{ CompartType.ComponenetType }}</td>
          <td class="text-center" *ngFor="let component of imageList.ToolDeatails; let i = index">
            <span *ngFor="let AllImageList of imageList.ComponentImageList; let j = index">
              <img *ngIf="AllImageList.comparttype_auto == CompartType.comparttype_auto && component.tool_auto == AllImageList.tool_auto && AllImageList.AttachmentName != 'NA'"
                   class="observation-image__photo" (click)="viewObservationImage(AllImageList.AttachmentPath, AllImageList)"
                   [src]="getImage(AllImageList.AttachmentPath)" />
              <div *ngIf="AllImageList.comparttype_auto == CompartType.comparttype_auto && component.tool_auto == AllImageList.tool_auto && AllImageList.AttachmentName == 'NA'"
                   class="upload-container" (click)="fileInput.click()" title="{{ 'Add photo' | translate | async }}">
                <i class="material-icons upload-container__icon">add_a_photo</i>
                <input style="display: none;" type="file" #fileInput (change)="onSelectPhoto($event,component.tool_auto,CompartType.comparttype_auto  )">
              </div>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>